import React from 'react';

import { Flex, rem } from '@vimeo/bokeh';
import { Checkmark } from '@vimeo/bokeh-icons';

import { enterpriseDefaultFeatures } from '../../utils/constants';

interface FeatureItemProps {
  text: string;
}

const FeatureItem = ({ text }: FeatureItemProps) => (
  <Flex margin={`${rem(8)} 0`} color={'white'} fontWeight={500} listStyleType={'none'}>
    <li>
      <Checkmark
        position={'relative'}
        top={rem(4)}
        width={rem(20)}
        height={rem(20)}
        marginRight={rem(8)}
        color={'white'}
      />
      {text}
    </li>
  </Flex>
);

const FeatureItems = () => {
  const features = enterpriseDefaultFeatures.featuresList || [];

  return (
    <Flex direction={'column'}>
      {features.map((text: string, index: number) => (
        <FeatureItem key={String(index)} text={text} />
      ))}
    </Flex>
  );
};

export default FeatureItems;
